module.exports = __webpack_public_path__ + "img/UTKODA-6.4fb36069.jpg";